import React from 'react';
import { Placeholder } from 'semantic-ui-react';

export const LoadingActivityFeedEvent: React.FC = () => {
    return (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div>
                <Placeholder style={{ width: 32, height: 32 }}>
                    <Placeholder.Image />
                </Placeholder>
            </div>
            <div style={{ flexGrow: 1, marginLeft: '.5rem' }}>
                <Placeholder style={{ marginTop: '-14px', marginBottom: '14px' }}>
                    <Placeholder.Line length="short" />
                    <Placeholder.Line length="full" />
                    <Placeholder.Line length="full" />
                </Placeholder>
            </div>
        </div>
    );
};